import { render } from "./CounterForm.vue?vue&type=template&id=bbfc3a06"
import script from "./CounterForm.vue?vue&type=script&lang=js"
export * from "./CounterForm.vue?vue&type=script&lang=js"

import "./CounterForm.vue?vue&type=style&index=0&id=bbfc3a06&lang=scss"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__